// MonitoringPanel.tsx
import React from 'react';
import classNames from 'classnames';
import { PepWatchMonitorData } from '../../types/PepTypes';
  
export interface MonitoringPanelProps {
  className?: string;
  data: PepWatchMonitorData | undefined;
}
const PepWatchMonitor: React.FC<MonitoringPanelProps> = ({ 
  className,
  data,
}) => {
  //calculate perventages
  const pepWatchCount = data?.pepWatchCount || 0;
  const sanctionsWatchCount = data?.sanctionsWatchCount || 0;
  const flaggedPepCount = data?.flaggedPepCount || 0;
  const flaggedSanctionsCount = data?.flaggedSanctionsCount || 0;

  const flaggedPepPercentage = pepWatchCount > 0 ? (flaggedPepCount / pepWatchCount) * 100 : 0;
  const flaggedSanctionsPercentage = sanctionsWatchCount > 0 ? (flaggedSanctionsCount / sanctionsWatchCount) * 100 : 0;
  
  return (
    <div className={classNames('monitoring-panel', className)}>
      <div className="monitoring-panel__content">
        <div className="monitoring-panel__header">
          <div className="monitoring-panel__header-cell monitoring-panel__header-cell--first">
            <div style={{height: '100%'}} className="monitoring-panel__header-content monitoring-panel__title">
              <span style={{marginBottom: '5px'}}>
                Vöktun
              </span>
            </div>
          </div>
          <div className="monitoring-panel__header-cell">
            <div className="monitoring-panel__header-content">PEP eftir kennitölu</div>
          </div>
          <div className="monitoring-panel__header-cell">
            <div className="monitoring-panel__header-content">Alþjóðlegir válistar</div>
          </div>
        </div>
        
        <div className="monitoring-panel__data-section">
          <div className="monitoring-panel__active-monitor">
            <div className="monitoring-panel__active-row">
              <div className="monitoring-panel__cell monitoring-panel__cell--first monitoring-panel__cell--active">
                <div className="monitoring-panel__cell-content">Virkir í vöktun</div>
              </div>
              <div className="monitoring-panel__cell monitoring-panel__cell--active">
                <div className="monitoring-panel__cell-content">{data?.pepWatchCount.toLocaleString('is-IS') || '-'}</div>
              </div>
              <div className="monitoring-panel__cell monitoring-panel__cell--active monitoring-panel__cell--last">
                <div className="monitoring-panel__cell-content">{data?.sanctionsWatchCount.toLocaleString('is-IS') || '-'}</div>
              </div>
            </div>
            <div className="monitoring-panel__active-row monitoring-panel__active-row--secondary">
              <div className="monitoring-panel__cell monitoring-panel__cell--first monitoring-panel__cell--active monitoring-panel__cell--bottom">
                <div className="monitoring-panel__cell-content monitoring-panel__cell-content--italic">þar af vámerktir</div>
              </div>
              <div className="monitoring-panel__cell monitoring-panel__cell--active monitoring-panel__cell--bottom">
                <div className="monitoring-panel__cell-content monitoring-panel__cell-content--italic">
                  { data?.flaggedPepCount.toLocaleString('is-IS') ?? '-' } {flaggedPepPercentage > 0 && `(${flaggedPepPercentage.toFixed(1)}%)`}
                </div>
              </div>
              <div className="monitoring-panel__cell monitoring-panel__cell--active monitoring-panel__cell--last monitoring-panel__cell--bottom">
                <div className="monitoring-panel__cell-content monitoring-panel__cell-content--italic">
                  { data?.flaggedSanctionsCount.toLocaleString('is-IS') ?? '-' } {flaggedSanctionsPercentage > 0 && `(${flaggedSanctionsPercentage.toFixed(1)}%)`}
                </div>
              </div>
            </div>
          </div>
          
          <div className="monitoring-panel__inactive-monitor">
            <div className="monitoring-panel__cell monitoring-panel__cell--first monitoring-panel__cell--inactive">
              <div className="monitoring-panel__cell-content">Óvirkir í vöktun</div>
            </div>
            <div className="monitoring-panel__cell monitoring-panel__cell--inactive">
              <div className="monitoring-panel__cell-content">{data?.inactivePepCount.toLocaleString('is-IS') || '-'}</div>
            </div>
            <div className="monitoring-panel__cell monitoring-panel__cell--inactive monitoring-panel__cell--last">
              <div className="monitoring-panel__cell-content">{data?.inactiveSanctionsCount.toLocaleString('is-IS') || '-'}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default PepWatchMonitor;